import { render, staticRenderFns } from "./ElTableColumnActions.vue?vue&type=template&id=7b5e229a&scoped=true"
import script from "./ElTableColumnActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElTableColumnActions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ElTableColumnActions.vue?vue&type=style&index=0&id=7b5e229a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5e229a",
  null
  
)

export default component.exports